/// <amd-module name="Wit/Common/Extensions" />

export const EXTENSION_HOST_RESIZED = "external-content-host-resized";

/** The resize options for a contribution host */
export enum ResizeOptions {
    /**
     * Default resize option which means both height and width resizing are allowed 
     */
    Default = 0,

    /**
     * The height of the host cannot be changed
     */
    FixedHeight = 2,

    /**
     * The width of the host cannot be changed
     */
    FixedWidth = 4
}
